import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { Container } from '../../components/ui';

/** Shared frame for every authentication screen. */
export function AuthShell({
  title,
  subtitle,
  children,
  footer,
}: {
  title: string;
  subtitle?: ReactNode;
  children: ReactNode;
  footer?: ReactNode;
}) {
  return (
    <Container className="flex min-h-[calc(100vh-4rem)] items-center justify-center py-12">
      <div className="w-full max-w-md">
        <div className="rounded-card border border-hull-700 bg-hull-800/60 p-7 backdrop-blur">
          <h1 className="text-xl font-semibold text-white">{title}</h1>
          {subtitle && <p className="mt-2 text-sm leading-relaxed text-hull-300">{subtitle}</p>}
          <div className="mt-6">{children}</div>
        </div>

        {footer && <div className="mt-5 text-center text-sm text-hull-400">{footer}</div>}

        <p className="mt-6 text-center text-xs text-hull-500">
          <Link to="/" className="hover:text-hull-300">
            ← Back to wave
          </Link>
        </p>
      </div>
    </Container>
  );
}

/** Renders per-field errors returned by the API alongside a general message. */
export function fieldErrors(
  fields: Record<string, string[]> | undefined,
  name: string,
): string[] | undefined {
  return fields?.[name];
}
